import {
  getReconStatusWarningSeverity,
  isPositionWarning,
  PositionWarnings,
  type PositionReconStatus,
  type PositionWarning,
} from '@talos/kyoko';
import type { PositionsBlotterRow } from '../../../../Blotters/PositionsV3/positionBlotterRow';

export type PositionWarningSource = Pick<PositionsBlotterRow, 'Asset'> & {
  ReconStatus?: PositionReconStatus;
  reconWarning?: PositionWarning;
};

export function getPositionWarning(data: PositionWarningSource): PositionWarning | undefined {
  const existingWarning = data.reconWarning;
  if (isPositionWarning(existingWarning)) {
    return existingWarning;
  }

  if (data.ReconStatus == null) {
    return undefined;
  }
  const { ReconStatus: reconStatus } = data;

  const severity = getReconStatusWarningSeverity(reconStatus.Status);
  if (severity == null) {
    return undefined;
  }

  return {
    severity,
    asset: data.Asset,
    reconStatus,
  };
}

export function renderPositionWarningDetails(data: PositionsBlotterRow) {
  const warning = getPositionWarning(data);
  return warning == null ? null : <PositionWarnings warning={warning} variant="mobileDetail" />;
}
